// Module
var code = "<div class=block-ui-overlay></div> <div class=block-ui-message-container aria-live=assertive aria-atomic=true> <i class=\"far fa-circle-notch fa-spin fa-3x fa-fw\"></i><span class=sr-only translate>Loading</span> </div> ";
// Exports
module.exports = code;